import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { TimeFormatToggle } from '../../../../SideBar/SettingsModal/TimeFormatToggle';
import { SETTING_ICONS } from '../../../constants';
import './TimeFormatSection.scss';

const TimeFormatSection: FC = () => {
  const Icon = SETTING_ICONS.clock;
  const { t } = useTranslation();

  return (
    <div className="time-format-section time-format-section--new-tabs">
      <div className="time-format-section__block">
        <Stack gap={1} direction="row" alignItems="center">
          <Icon className="time-format-section__section-icon" />
          <Typography variant="body1" className="time-format-section__section-title">
            {t('settings.general.timeFormat')}
          </Typography>
        </Stack>
        <TimeFormatToggle />
      </div>
    </div>
  );
};

export default TimeFormatSection;
